export enum MediaLibraryWorkspaceCapabilityUdoTemplateKey {
    dirent = "4c2c57b5-6d78-48c1-a6ec-50a02f526ec0",
    direntEvent = "5249b534-a249-48f0-99bd-f44da205188f",
}
